module.exports = "pegasus_template/assets/blocks/pop-up-element-image.png";